import React, { useEffect, useState, useRef } from 'react'
import { FaSearch, FaPlusCircle } from 'react-icons/fa';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine } from 'react-icons/ri';
import '../styles/FaqsAdmin.css';
import '../styles/BannersDash.css';
import axios from 'axios';
import config from '../../../constants/config';
import { useSlideout } from '../../../hooks/SlideoutContext';
import { IoMdRefresh } from 'react-icons/io';

export default function FaqsAdmin() {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const { openSlideout, closeSlideout } = useSlideout();
    
    useEffect(() => {
        fetchFaqs();
    }, []);

    const fetchFaqs = () => {
        setLoading(true);

        axios.post(config.api.url + 'admin/faqs/fetch', {}, {
            crossdomain: true,
            headers: {
                'api': config.api.key,
                'auth': 'b8GjLbLHDX9isF10ptWj',
            }
        })
        .then((json) => {
            const { success, response, data } = json.data;

            if(success){
                setFaqs(data);
            } else {
                console.log(response);
            }
            setLoading(false);
        })
        .catch(function (error) {
            console.error("Fetch error:", error);
            setLoading(false);
        });
    };
    
    const EditFaq = ({ faq }) => {
        const { closeSlideout } = useSlideout();
        const [faqData, setFaqData] = useState({
            id: faq.id,
            question: faq.question,
            answer: faq.answer,
            active: faq.active === 1
        });

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFaqData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle save changes
        const handleSaveChanges = () => {
            const formData = new FormData();
            formData.append("id", faqData.id);
            formData.append("question", faqData.question);
            formData.append("answer", faqData.answer);
            formData.append("active", faqData.active ? 1 : 0);

            axios.post(config.api.url + "admin/faqs/update", formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    fetchFaqs();
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error("Update error:", error);
            });
        };

        return (
            <div className="EditBannerContainer">
                <div className="EditBannerOptions">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Question</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="question" 
                                value={faqData.question} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Answer</div>
                        <div className="EditBannerOptionContent">
                            <textarea 
                                name="answer" 
                                value={faqData.answer} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                rows="6"
                                style={{ resize: 'vertical' }}
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Active</div>
                        <div className="EditBannerOptionContent">
                            <label className="EditBannerCheckboxLabel">
                                <input 
                                    type="checkbox" 
                                    name="active" 
                                    checked={faqData.active} 
                                    onChange={handleChange} 
                                    className="EditBannerCheckbox"
                                />
                                <span>Show on website</span>
                            </label>
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={handleSaveChanges}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };
    
    const AddFaq = () => {
        const { closeSlideout } = useSlideout();
        const [faqData, setFaqData] = useState({
            question: "",
            answer: "",
            active: true
        });

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFaqData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle save changes
        const handleSaveChanges = () => {
            const formData = new FormData();
            formData.append("question", faqData.question);
            formData.append("answer", faqData.answer);
            formData.append("active", faqData.active ? 1 : 0);

            axios.post(config.api.url + "admin/faqs/add", formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    fetchFaqs();
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error("Add error:", error);
            });
        };

        return (
            <div className="EditBannerContainer">
                <div className="EditBannerOptions">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Question</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="question" 
                                value={faqData.question} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="Enter the question"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Answer</div>
                        <div className="EditBannerOptionContent">
                            <textarea 
                                name="answer" 
                                value={faqData.answer} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                rows="6"
                                style={{ resize: 'vertical' }}
                                placeholder="Enter the answer"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Active</div>
                        <div className="EditBannerOptionContent">
                            <label className="EditBannerCheckboxLabel">
                                <input 
                                    type="checkbox" 
                                    name="active" 
                                    checked={faqData.active} 
                                    onChange={handleChange} 
                                    className="EditBannerCheckbox"
                                />
                                <span>Show on website</span>
                            </label>
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={handleSaveChanges}
                        >
                            Add FAQ
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='BannersDash'>
            <div className='BannersHeader'>
                <div className='BannersHeaderTitle'>
                    <h1>FAQs</h1>
                    <p>Manage frequently asked questions that appear on your website</p>
                </div>
                <div className='BannersHeaderActions'>
                    <button className='BannersRefreshButton' onClick={fetchFaqs}>
                        <IoMdRefresh />
                        <span>Refresh</span>
                    </button>
                    <button 
                        className='BannersAddButton'
                        onClick={() => {
                            openSlideout({
                                title: 'Add New FAQ',
                                content: <AddFaq />
                            });
                        }}
                    >
                        <FaPlusCircle />
                        <span>Add New</span>
                    </button>
                </div>
            </div>

            <div className='BannersContent'>
                <div className='BannersContentNavigation'>
                    <div className='BannersContentNavigationItem ID' style={{flex: 'none', width: '60px'}}>ID</div>
                    <div className='BannersContentNavigationItem Active' style={{flex: 'none', width: '80px'}}>Active</div>
                    <div className='BannersContentNavigationItem Title'>Question</div>
                    <div className='BannersContentNavigationItem Subtitle'>Answer</div>
                </div>
                <div className='BannersScroll'>
                    {faqs.map((faq, index) => {
                        return (
                            <div className='BannerItem' key={faq.id}>
                                <div className="BannerItemDetailsText First ID Bold">{faq.id}</div>
                                <div className="BannerItemDetailsText Active">
                                    <span className={`BannerItemDetailsTextOption Circle ${faq.active ? 'Success' : 'Error'}`}>
                                        {faq.active
                                            ? <RiCheckFill style={{ fontSize: 12 }} />
                                            : <RiCloseFill style={{ fontSize: 12 }} />
                                        }
                                    </span>
                                </div>
                                <div className="BannerItemDetailsText Title">{faq.question}</div>
                                <div className="BannerItemDetailsText Subtitle">{faq.answer}</div>

                                <div className="BannerItemOptions">
                                    <a 
                                        onClick={() => {
                                            // Toggle active status
                                            console.log(`Toggle active status for FAQ ${faq.id}`);
                                        }} 
                                        className={`BannerItemOptionsButton ${faq.active ? 'DeleteInverted' : 'AddInverted'}`}
                                    >
                                        {faq.active
                                            ? <RiToggleFill style={{ fontSize: 14 }} />
                                            : <RiToggleLine style={{ fontSize: 14 }} />
                                        }
                                        <span className="BannerItemOptionsButtonText">
                                            {faq.active ? 'Deactivate' : 'Activate'}
                                        </span>
                                    </a>

                                    <a 
                                        onClick={() => {
                                            openSlideout({
                                                title: 'Edit FAQ',
                                                content: <EditFaq faq={faq} />
                                            });
                                        }} 
                                        className="BannerItemOptionsButton Edit"
                                    >
                                        <RiFileShield2Line style={{ fontSize: 14 }} />
                                        <span className="BannerItemOptionsButtonText">Edit</span>
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='BannersPaginationWrapper'>
                    {/* Pagination will be added here when needed */}
                </div>
            </div>
        </div>
    )
}
